<template>
  <div class="news">
    <div>
      <h1>News</h1>
    </div>

    <!-- Display news -->
    <div v-for="item in sortedNews" :key="item.ID" class="card mb-3">
      <!-- News picture -->
      <img :src="item.picture" class="card-img-top" :alt="item.picture" />

      <div class="card-body">
        <!-- News title -->
        <h5 class="card-title">{{ item.title }}</h5>

        <!-- News text -->
        <p v-html="parseText(item.text)" class="card-text"></p>

        <!-- News date -->
        <p class="card-text">
          <small class="text-muted"
            >Last updated {{ formatDate(item.Date) }}</small
          >
        </p>

        <!-- Access devel buttons -->
        <div v-if="accessDevel" class="buttons">
          <!-- Edit news button -->
          <button
            @click="editNews(item)"
            class="btn btn-outline-secondary"
            type="button"
          >
            <i class="bi bi-pen"></i>
          </button>

          <!-- Delete news button -->
          <button
            @click="toggleInput(item.ID)"
            class="btn btn-outline-secondary"
            type="button"
          >
            <i class="bi bi-trash"></i>
          </button>

          <!-- Confirm action -->
          <div
            class="from-group mt-3"
            v-if="confirmWord && confirmItemId === item.ID"
          >
            <ActionConfirm
              :action="confirmWord"
              @confirm="sendCmdNewsDel"
              @cancel="doCancelConfirm"
            />
          </div>
        </div>

        <!-- Read news button -->
        <button
          v-if="item.is_readed === false"
          @click="sendCmdNewsIsRead(item.ID)"
          class="text-success check-button bottom-0 end-0 m-2"
        >
          <i class="bi bi-check-lg h5"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Go to top button -->
  <GoTop />
</template>

<script>
import ActionConfirm from "../ActionConfirm.vue";
import GoTop from "../GoTop.vue";

const cmdNewsList = "news.list/";
const cmdNewsDel = "news.del";
const cmdNewsIsRead = "news.isreaded/";
const cmdAccessDevel = "login.access-devel";

export default {
  name: "PageNews",
  components: {
    ActionConfirm,
    GoTop,
  },

  data() {
    return {
      news: [],
      previous: "",
      processGetPage: false,
      accessDevel: false,
      showActionConfirm: false,
      confirmWord: "",
      previousHref: "",
      confirmItemId: null,
    };
  },

  mounted() {
    let that = this;

    this.previousHref = window.location.href;

    // Add reader
    this.reader = this.teoweb.addReader(function (gw, data) {
      // Check error
      if (gw.err) {
        that.error = "Error: " + gw.err;
        return;
      }
      that.error = "";

      if (gw.command.startsWith(cmdNewsDel)) {
        // Get second parameter from gw.command
        let id = gw.command.split("/")[1];
        that.deleteNews(id);
      }

      // Process answer
      switch (gw.command) {
        // Process answer to sendCmdNewsList command
        case cmdNewsList + that.previous: {
          that.processGetPage = false;

          that.webasmReady.then(() => {
            let response = JSON.parse(data);

            if (response.rows && response.rows.length > 0) {
              that.news = that.news.concat(response.rows);
              that.previous = response.pagination;
            } else {
              that.previous = "";
            }
          });
          break;
        }

        // Get developer access
        case cmdAccessDevel: {
          if (gw.err) {
            that.accessDevel = false;
            return;
          }
          that.accessDevel = true;
        }
      }
    });

    this.whenLogin.then(() => {
      that.sendCmdNewsList();
      that.teoweb.sendCmd(cmdAccessDevel);
    });
  },

  unmounted() {
    this.teoweb.delReader(this.reader);
  },

  computed: {
    sortedNews() {
      return [...this.news].sort((a, b) => new Date(b.Date) - new Date(a.Date));
    },
  },

  methods: {
    // Methods sendCmdNewsList gets entries from database
    sendCmdNewsList() {
      this.processGetPage = true;
      this.teoweb.sendCmd(cmdNewsList + this.previous);
    },

    sendCmdNewsIsRead(id) {
      this.teoweb.sendCmd(cmdNewsIsRead + id);

      this.news = this.news.map((item) => {
        if (item.ID === id) {
          return { ...item, is_readed: true };
        }
        return item;
      });
    },

    // Method sendCmdNewsDel deletes entry from database by ID
    sendCmdNewsDel() {
      this.teoweb.sendCmd(cmdNewsDel + "/" + this.confirmItemId);
    },

    deleteNews(id) {
      this.news = this.news.filter((item) => item.ID !== id);
    },

    // Method formatDate shows accepted date in convenient format
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}.${month}.${day}`;
    },

    // Method toggleInput shows or hides confirm group
    toggleInput(itemId) {
      this.showActionConfirm = !this.showActionConfirm;
      this.confirmItemId = this.showActionConfirm ? itemId : null;

      if (this.showActionConfirm) {
        this.confirmWord = {
          name: "delete",
          text: "Are you sure you want to delete this news?",
          word: "confirm",
        };
      } else {
        this.confirmWord = null;
      }
    },

    doCancelConfirm() {
      this.confirmWord = null;
      this.confirmItemId = null;
    },

    editNews(news) {
      sessionStorage.setItem("news", JSON.stringify(news));

      window.location.href = "#/write_news/" + news.ID;
    },

    // Parse news text
    parseText(text) {
      // Replace new line with <br> tag
      if (!text) return "";
      return text.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped>
.news {
  width: 640px;
  max-width: 100%;
}

.buttons button {
  margin-right: 0.5rem;
}

.check-button {
  position: absolute;
  background: none;
  border: none;
  margin-bottom: 10px !important;
}
</style>

<!-- Not scoped styles inside the v-html -->
<style>
.news p.card-text img {
  max-width: 100%;
}
</style>
